import React from 'react';
import PropTypes from 'prop-types';
import styles from './user.module.scss';
import { formatDate } from '../../../shared/utils/formatDate';
import { formatUsername } from '../../../shared/utils/roles';

const roleLabels = {
  superadmin: 'Super admin',
  admin: 'Admin',
  pharmacy: 'Apoteka',
  manager: 'Menadzer',
  user: 'Korisnik',
};

const UserDetails = ({ user }) => {
  return (
    <div className={styles.accountDetails}>
      <div className={styles.accountDetails__meta}>
        <div className={styles.accountDetails__field}>
          <span className={styles.accountDetails__label}>
            Korisnik registrovan
          </span>
          <span className={styles.accountDetails__value}>
            {formatDate(
              user?.registeredAt ? user.registeredAt : user?.createdAt
            )}
          </span>
        </div>
        <div className={styles.accountDetails__field}>
          <span className={styles.accountDetails__label}>Verifikacija</span>
          <span className={styles.accountDetails__value}>
            {user?.isVerified ? 'Verifikovan' : 'Nije verifikovan'}
          </span>
        </div>
        <div className={styles.accountDetails__field}>
          <span className={styles.accountDetails__label}>Rola</span>
          <span className={styles.accountDetails__value}>
            {user?.role ? roleLabels[user.role] : 'Nepoznata uloga'}
          </span>
        </div>
      </div>

      <div className={styles.accountDetails__divider} />

      <div className={styles.accountDetails__row}>
        <div className={styles.accountDetails__field}>
          <span className={styles.accountDetails__label}>Ime</span>
          <span className={styles.accountDetails__value}>
            {user?.firstName || '-'}
          </span>
        </div>
        <div className={styles.accountDetails__field}>
          <span className={styles.accountDetails__label}>Prezime</span>
          <span className={styles.accountDetails__value}>
            {user?.lastName || '-'}
          </span>
        </div>
      </div>

      {user?.username ? (
        <div className={styles.accountDetails__field}>
          <span className={styles.accountDetails__label}>Korisnicko ime</span>
          <span className={styles.accountDetails__value}>
            {formatUsername(user.username)}
          </span>
        </div>
      ) : (
        <div className={styles.accountDetails__field}>
          <span className={styles.accountDetails__label}>Email</span>
          <span className={styles.accountDetails__value}>
            {user?.email || '-'}
          </span>
        </div>
      )}
    </div>
  );
};

UserDetails.propTypes = {
  user: PropTypes.object,
};

export default UserDetails;
